import { memo, useEffect } from 'react'
import { useTemplateDialog } from '../../providers/TemplateDialogProvider'

const TemplatePage = () => {
  const { openTemplateDialog, closeTemplateDialog } = useTemplateDialog()
  useEffect(() => {
    openTemplateDialog()
    return () => {
      closeTemplateDialog()
    }
  })
  return null
}

export default memo(TemplatePage)
